import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-entity-sure-flow-unit',
    templateUrl: './entity-sure-flow-unit.component.html',
    styleUrls: ['./entity-sure-flow-unit.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class EntitySureFlowUnitComponent {

}
